module.exports = __webpack_public_path__ + "img/sticker.f9c44426.png";